/////////////-----------------Service Action------------------///////////
export const GET_SERVICES = "GET_SERVICES";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAIL = "GET_SERVICES_FAIL";
export const UPDATE_SERVICES_LIST = "UPDATE_SERVICES_LIST";

export const GET_SERVICES_BY_ID = "GET_SERVICES_BY_ID";
export const GET_SERVICES_BY_ID_SUCCESS = "GET_SERVICES_BY_ID_SUCCESS";
export const GET_SERVICES_BY_ID_FAIL = "GET_SERVICES_BY_ID_FAIL";

export const ADD_SERVICE = "ADD_SERVICE";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAIL = "ADD_SERVICE_FAIL";

export const REMOVE_SERVICE = "REMOVE_SERVICE";
export const REMOVE_SERVICE_SUCCESS = "REMOVE_SERVICE_SUCCESS";
export const REMOVE_SERVICE_FAIL = "REMOVE_SERVICE_FAIL";

export const EDIT_SERVICE = "EDIT_SERVICE";
export const EDIT_SERVICE_SUCCESS = "EDIT_SERVICE_SUCCESS";
export const EDIT_SERVICE_FAIL = "EDIT_SERVICE_FAIL";
